import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoveFolder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMoveFolder"><Path d="M12.5 19.5H2.5V3.5H10L12 6.5H21.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 17.5H18.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 14.5L22.5 17.5L19.5 20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconMoveFolder;
